export const Trashcan = () => {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_667_2017)">
        <path
          d="M1.57129 5.99944H20.4284M7.07129 5.99944V5.21373C7.07129 4.17181 7.48519 3.17256 8.22194 2.43581C8.95869 1.69906 9.95794 1.28516 10.9999 1.28516C12.0418 1.28516 13.041 1.69906 13.7778 2.43581C14.5145 3.17256 14.9284 4.17181 14.9284 5.21373V5.99944M8.64272 10.7153V17.0042M13.357 10.7153V17.0042M3.92843 5.99944H18.0713V20.1423C18.0713 20.5591 17.9057 20.9588 17.611 21.2535C17.3163 21.5482 16.9166 21.7137 16.4999 21.7137H5.49986C5.08309 21.7137 4.68339 21.5482 4.38869 21.2535C4.09399 20.9588 3.92843 20.5591 3.92843 20.1423V5.99944Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_667_2017">
          <rect width="22" height="22" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
